module.exports = "#top-nav h1.support {\n    color: #fff;\n    font-size: 22px;\n    line-height: 48px;\n    margin: 3px;\n}\n\n.support-main {\n    width: 960px;\n    margin: 0 auto;\n}\n\n.support-section {\n    background: #fff;\n}\n\n.supportimg img {\n    height: 450px;\n}\n\n.support-main p {\n    text-align: center;\n}\n\n/*.supportimg img{\n    max-width:100%;\n    display:inline-block; \n    float:left;\n    width: 30%;\n    margin:0 30px 25px 0px; \n}\n.supportimg img:last-child{\n    margin:0 0px 25px 0px; \n}*/"


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy/support/support.component.css
// module id = ./src/app/privacy/support/support.component.css
// module chunks = main